<template>
	<div
		@click.stop="handleClick"
		class="link-large-underline link-default py-2 px-3 cursor-pointer"
	>
		<slot>{{ props.text }}</slot>
	</div>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits } from "vue";

interface Props {
	text?: string;
}
interface Emits {
	(e: "click"): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const handleClick = () => {
	emit("click");
};
</script>

<style scoped>
button {
	border: none;
}
</style>
